module.exports = __webpack_public_path__ + "img/good-morning.134f9aa7.png";